<template>
  <div>
    <Modal v-model="userForm" title="修改用户" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
        <Row>
            <Col span="24">
                <FormItem label="账号" prop="userId" :class="{requireStar:true}" >
                  <Input v-model="formValidate.userId" :readonly="true" :maxlength="10" ></Input>
                </FormItem>
            </Col>
        </Row>
         <Row>
            <Col span="24">
              <FormItem label="选择区域" prop="regionCode">
                <RadioGroup v-model="formValidate.regionCode">
                  <span @click="selRegion(2)"><Radio label="2">市</Radio></span>
                  <span @click="selRegion(3)"><Radio label="3">区/县</Radio></span>
                </RadioGroup>
             </FormItem>
            </Col>
        </Row>
        <Row v-show="showDist">
            <Col span="24">
                  <FormItem label="所属区县级">
                     <Select ref="selectDist" v-model="formValidate.dist" :clearable="true" style="width:200px">
                        <Option v-for="item in distList" :value="item.groupid" :key="item.groupid">
                          {{ item.groupname }}</Option>
                    </Select>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="用户类型" prop="userType">
                    <RadioGroup v-model="formValidate.userType">
                      <Radio label="4">管理员</Radio>
                      <Radio label="2">操作者</Radio>
                    </RadioGroup>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="特殊权限(复选)" prop="role">
                    <CheckboxGroup v-model="formValidate.role" >
                      <Checkbox label="2" >资产管理</Checkbox>
                    </CheckboxGroup>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="用户描述" prop="userDescription">
                    <Input v-model="formValidate.userDescription" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input>
                  </FormItem>
            </Col>
        </Row>
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    components:{
    },
    data() {
      return {
        userForm: false,
        title: '',
        show: true,
        showDist: false,
        distList: [],
        formValidate: {
          id: '',
          dist: '',
          userId: '',
          userPassword: '',
          userPassword2: '',
          regionCode: '',
          userState:'',
          userType:'',
          userDescription:'',
          LastLogonTime:'',
          role:[],
          assetsManage:'',
        },
        ruleValidate: {
          userType: [{
            required: true,
            message: '用户类型不能为空',
            trigger: 'change'
          }],
        },
      }
    },

    methods: {
      openModal(row) {
        
        this.userForm = true
        this.handleReset("formValidate");
        this.initUpdate(row)
        this.initRegionCode()
      },
      //修改初始化
      initUpdate(row){
            let url = `/province/sys/user/${row.id}`;
            this.req({
              url: url,
              method: 'get',
            }).then(resp => {
                let user = resp.data.data;
                this.formValidate.id = user.id
                this.formValidate.userId = user.userId
                this.formValidate.userDescription = user.userDescription
                this.formValidate.userType = user.userType
                this.formValidate.dist = user.regionCode
                this.formValidate.role = user.roleID.split(',')
                let rc  = user.regionCode
                
                if(rc.length == 4) {//如果是市级
                  this.formValidate.regionCode = '2'
                } else if(rc.length == 6) {//如果是区县
                  this.formValidate.regionCode = '3'
                  this.formValidate.city = rc.substring(0,4)
                  this.formValidate.dist = rc.substring(0,6)
                  this.showDist = true
                  this.getDist()
                }
              
            }).catch(error => {
                this.reponseData = "发生错误，无法显示内容"
            })
      },
      initRegionCode(){
            let url = "/province/sys/dcBsgroup/listByParentCode";
            this.req({
              url: url,
              method: 'post',
              data:{
                parentCode: this.$store.state.user.regionCode
              }
            }).then(resp => {
                this.distList = resp.data.list
            }).catch(error => {
                console.log("发生错误："+error)
            })
      },
      handleSubmit(name) {

         //设置区域编码
         let regCode = null ;
          if (this.formValidate.regionCode == '2') {
            regCode = this.$store.state.user.regionCode
          }else if (this.formValidate.regionCode == '3') {
            regCode = this.formValidate.dist
          }
          if (regCode == null || regCode == '') {
              this.$Message.error('请选择区域!');
              return
          }
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url = "/province/sys/user/save";
            let myData = {
              id: this.formValidate.id,
              regionCode: regCode,
              userId: this.formValidate.userId,
              userType: this.formValidate.userType,
              userDescription: this.formValidate.userDescription,
              roleID: this.formValidate.role.join(","),
              assetsManage: 1,
            }
            console.log(myData)
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
              if (response.status == 200) {
                this.$Message.success('保存成功!');
                this.$parent.loadPage();
              } else {
                this.$Message.error('服务器错误:' + response.status);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
      //选择市、区
      selRegion(){
        //获取选中的区域类型
        let id = arguments[0]
          //保存用户的区域类型
        this.formValidate.regionCode = id
        //如果选择区县
        if(id == 3){
          this.showDist = true
        }else{
          if (this.$refs.selectdist) {
           this.$refs.selectdist.clearSingleSelect()
          }
          this.showDist = false
        }
       
      },
       getDist(){
            //先清空原有数据
            this.distList = []
            let url = "/province/sys/dcBsgroup/listByParentCode";
            this.req({
              url: url,
              method: 'post',
              data:{
                parentCode: this.formValidate.city 
              }
            }).then(resp => {
                this.distList = resp.data.list
               // console.log(this.distList)
            }).catch(error => {
                console.log("发生错误："+error)
            })
      },
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/sys/user/UserFormUpdateCity.vue